package com.qrkontaq.core.tenant

import kotlinx.browser.window
import org.w3c.dom.url.URLSearchParams

/**
 * Resolves the tenant (restaurant) from the hostname: cafename.qrkontaq.com -> "cafename".
 * On localhost the ?tenant= query parameter is used instead so the tenant site can be
 * developed without wildcard DNS.
 */
object Tenant {

    private const val PLATFORM_ADMIN_SUBDOMAIN = "adminkontaq"

    private val reservedSubdomains = setOf("www", "app", "admin", "api", "auth", PLATFORM_ADMIN_SUBDOMAIN)

    val slug: String? by lazy { resolve() }

    val isTenantSite: Boolean get() = slug != null

    /**
     * The platform owner's dashboard lives on its own subdomain
     * (adminkontaq.qrkontaq.com). On localhost use ?platform to preview.
     */
    val isPlatformAdminSite: Boolean by lazy {
        val hostname = window.location.hostname
        if (hostname == "localhost" || hostname == "127.0.0.1") {
            URLSearchParams(window.location.search).get("platform") != null
        } else {
            hostname.split(".").firstOrNull()?.lowercase() == PLATFORM_ADMIN_SUBDOMAIN
        }
    }

    private fun resolve(): String? {
        val hostname = window.location.hostname

        if (hostname == "localhost" || hostname == "127.0.0.1") {
            return URLSearchParams(window.location.search).get("tenant")
                ?.trim()?.lowercase()?.takeIf { it.isNotEmpty() }
        }

        val parts = hostname.split(".")
        // cafename.qrkontaq.com -> 3 parts; qrkontaq.com -> 2 parts (landing)
        if (parts.size < 3) return null

        val sub = parts.first().lowercase()
        return sub.takeIf { it !in reservedSubdomains }
    }
}
